<template>
  <section class="job-post-detail-modal">
    <sweet-modal ref="modal" overlay-theme="light" allowfullscreen>
      <section class="main-content bg-light text-left" v-if="jobPost">
        <div class="row">
          <div class="col-12 p-0">
            <!-- Job Post Detail -->
            <section class="bg-white p-3">
              <div class="d-flex text-secondary text-small">
                <div class="flex-fill">
                  Job #{{ jobPost.code }}
                </div>
                <div class="flex-fill text-right">
                  {{ jobPost.created_at | prettyDate }}
                </div>
              </div>
              <div class="py-3 text-center">
                <div class="job-post-title">{{ jobPost.title }}</div>
                <div class="job-post-salary -status-alert mt-2"> {{ jobPost.min_salary | currency }} - {{
                    jobPost.max_salary
                      | currency }} / เดือน
                </div>
                <div class="mt-4">
                  <i class="fas fa-map-marker-alt -status-alert"></i> {{ jobPost.address_province | multiLangName }} - {{
                    jobPost.district | multiLangName }}
                </div>
                <div class="mt-2" v-if="jobPost.job_users.length > 0">
                  <i class="fas fa-user"></i> มี {{ jobPost.job_users.length }} คนสนใจ
                </div>
              </div>
            </section>

            <section class="bg-white p-3 mt-3">
              <h3>สวัสดิการ</h3>
              <div>
                <div><label>ที่พัก</label></div>
                {{ (jobPost.has_accommodation === 0) ? 'ไม่มีที่พักให้ (ไป-กลับ)' : 'มีที่พักให้' }}
              </div>
              <div class="mt-3" v-if="jobPost.job_post_welfares.length > 0">
                <div><label>สวัสดิการอื่น ๆ</label></div>
                <ul class="pl-4">
                  <li v-for="item, index in jobPost.job_post_welfares">
                    {{ item.job_welfare.name }}
                  </li>
                </ul>
              </div>
            </section>

            <section class="bg-white p-3 mt-3">
              <h3>คุณสมบัติ</h3>
              <div class="mt-3" v-if="jobPost.job_post_skills.length > 0">
                <div><label>ทักษะที่ต้องการ</label></div>
                <ul class="pl-4">
                  <li v-for="item, index in jobPost.job_post_skills">
                    {{ item.job_skill.name }}
                  </li>
                </ul>
              </div>
              <div class="mt-3" v-if="jobPost.job_post_languages.length > 0">
                <div><label>ภาษา</label></div>
                <ul class="pl-4 mb-0">
                  <li v-for="item, index in jobPost.job_post_languages">
                    {{ item.language.name }}
                  </li>
                </ul>
              </div>
            </section>

            <section class="bg-white p-3 mt-3">
              <h3>รายละเอียดงาน</h3>
              <div v-html="handleNewLine(jobPost.description)" v-linkified></div>
            </section>
          </div>
        </div>
        <div :style="`height: ${footerHeight}px;`">&nbsp;</div>
        <div class="bg-white border-top p-2"
             ref="sectionFooter"
             :class="{ 'bottom-button' : !$mq.desktop }">
          <div v-if="jobUser">
            <button class="btn btn-lg btn-outline-secondary btn-block p-2"
                    v-if="!isInterestedJob(jobPost)"
                    @click.prevent="openModalConfirm">
              <i class="fas fa-plus"></i> สนใจรับงานนี้
            </button>
            <button class="btn btn-lg btn-info btn-block p-2"
                    v-else
                    @click="deleteData()">
              <i class="fas fa-check"></i> ลงชื่อสนใจรับงานนี้แล้ว
            </button>
          </div>
          <div v-else>
            <div class="text-center">
              <span class="text-small">
                 ล็อกอิน หรือลงทะเบียนระบบ BeNeat Jobs<br>เพื่อสามารถกดสนใจรับงานนี้ได้
              </span>
              <div class="py-3">
                <a :href="apiUrl"
                   class="btn btn-success"
                   v-if="apiUrl">
                  <span class="d-inline-block pl-2">
                    <i class="fab fa-line fa-lg"></i>
                  </span>&nbsp;&nbsp;ล็อคอิน/ลงทะเบียน BeNeat Jobs ผ่าน LINE
                </a>
              </div>
            </div>
            <button class="btn btn-lg btn-outline-secondary btn-block p-2"
                    disabled>
              <i class="fas fa-plus"></i> สนใจรับงานนี้
            </button>
          </div>
        </div>
      </section>
    </sweet-modal>

    <sweet-modal ref="modalConfirm">
      <h3>ยืนยันสมัครงานประจำ</h3>

      <div class="card">
        <div class="card-header">
          Job #{{ jobPost.code }}
        </div>
        <div class="card-body">
          <h5 class="card-title">หมายเหตุ</h5>
          <p class="card-text text-left text-danger">
            <span>
            - ผู้สมัครยินยอมให้ส่งข้อมูลส่วนบุคคลใดๆ ก็ตามที่ได้กรอกผ่านแพลตฟอร์มนี้ทั้งหมด เพื่อให้ลูกค้าได้พิจารณาเลือกสัมภาษณ์ <br>
            - ผู้สมัครยืนยันว่าข้อมูลที่กรอกเข้ามาเป็นข้อมูลจริงทั้งหมด และยอมรับการพิจารณาของ BeNeat หากตรวจพบข้อมูลเท็จ
            </span>
          </p>
          <div>
            <a href="#" class="btn btn-primary" style="margin-right: 10rem;" @click.prevent="addData()">ยืนยัน</a>
            <a href="#" class="btn btn-danger" @click.prevent="$refs.modalConfirm.close()">ยกเลิก</a>
          </div>
        </div>
      </div>
    </sweet-modal>

    <update-profile-modal ref="updateProfileModal"></update-profile-modal>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { SweetModal } from 'sweet-modal-vue'
import { jobPostMixin } from '../../mixins/jobPostMixin'
import UpdateProfileModal from './UpdateProfileModal'

export default {
  mixins: [jobPostMixin],
  components: {
    SweetModal,
    UpdateProfileModal
  },
  data () {
    return {
      id: null,
      saved: false,
      footerHeight: null
    }
  },
  computed: {
    ...mapState('jobPost', ['jobPost']),
    ...mapState('jobUser', ['jobUser'])
  },
  methods: {
    ...mapActions('jobPost', ['fetchJobPostDetail', 'fetchJobPostDetailByCode']),
    ...mapActions('jobUser', ['addJobUserJobPost', 'deleteJobUserJobPost']),
    openModalConfirm () {
      let requireNameInputs = []
      if (!this.jobUser.working_experience) {
        requireNameInputs.push('working_experience')
      }
      if (!this.jobUser.introduce) {
        requireNameInputs.push('introduce')
      }
      if (!this.jobUser.address_province_id) {
        requireNameInputs.push('address_province_id')
      }
      if (!this.jobUser.district_id) {
        requireNameInputs.push('district_id')
      }
      if (!this.jobUser.disease) {
        requireNameInputs.push('disease')
      }

      if (requireNameInputs.length > 0) {
        this.$refs.modal.close()
        this.$refs.updateProfileModal.displayModal(true, requireNameInputs)
      } else {
        this.$refs.modalConfirm.open()
      }
    },
    async openModal (jobPostId) {
      this.id = jobPostId
      await this.fetchJobPostDetail(this.id)
      this.$refs.modal.open()
      setTimeout(() => {
        this.getFooterHeight()
      }, 500)
    },
    getFooterHeight () {
      this.footerHeight = 16
      if (!this.$mq.desktop) {
        this.footerHeight = this.$refs.sectionFooter.clientHeight + 16
      }
    },
    handleNewLine (str) {
      return str.replace(/(?:\r\n|\r|\n)/g, '<br />')
    },
    isInterestedJob (jobPost) {
      let result = false
      const jobUsers = jobPost.job_users
      if (jobUsers && jobUsers.length > 0) {
        for (let item of jobUsers) {
          if (this.jobUser.id === item.job_user_id) {
            result = true
            break
          }
        }
      }
      return result
    },
    async addData () {
      this.$refs.modalConfirm.close()
      const submitData = {
        job_post_id: this.jobPost.id,
        job_user_id: this.jobUser.id
      }
      await this.addJobUserJobPost(submitData)
      await this.fetchJobPostDetail(this.id)
      this.$store.commit('jobPost/UPDATE_JOB_POST', this.jobPost)
    },
    async deleteData () {
      const submitData = {
        job_post_id: this.jobPost.id,
        job_user_id: this.jobUser.id
      }
      await this.deleteJobUserJobPost(submitData)
      await this.fetchJobPostDetail(this.id)
      // Delete unsaved job post
      if (this.$route.query.type && this.$route.query.type === 'saved') {
        this.$store.commit('jobPost/DELETE_JOB_POST', this.jobPost)
      } else {
        this.$store.commit('jobPost/UPDATE_JOB_POST', this.jobPost)
      }
    }
  },
  async mounted () {
    // Check code
    if (this.$route.query.code) {
      const code = this.$route.query.code
      await this.fetchJobPostDetailByCode(code)
      if (this.jobPost) {
        this.openModal(this.jobPost.id)
      }
    }
  }
}
</script>

<style scoped>
.main-content {
  padding-bottom: 0;
}

.job-post-detail-modal >>> .sweet-content {
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-bottom: 0 !important;
}

.bottom-button {
  z-index: 10;
  height: auto;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.menu-text {
  color: #00ACC1 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/jobPost/JobPostDetailModal.vue